import { useEffect, useState } from 'react';
import type { StatusLookup } from './useStatusCounts';

/**
 * useLookupStatuses — loads a status lookup once, tolerating the two response shapes
 * the SDK status services return.
 *
 * `CasesListView` already guards for this (`(s as any)?.data ?? s ?? []`): some status
 * services hand back the bare array, others the `ResponseData` envelope. Centralised here
 * so the Overview's two status rows don't each repeat the check.
 */
export interface StatusLookupService {
  getAll: () => Promise<unknown>;
}

export function useLookupStatuses(service: StatusLookupService): StatusLookup[] {
  const [statuses, setStatuses] = useState<StatusLookup[]>([]);

  useEffect(() => {
    let cancelled = false;

    service.getAll()
      .then((res) => {
        if (cancelled) return;
        const rows = ((res as any)?.data ?? res ?? []) as StatusLookup[];
        setStatuses(Array.isArray(rows) ? rows : []);
      })
      .catch((e) => console.error('Error fetching status lookup:', e));

    return () => { cancelled = true; };
  }, [service]);

  return statuses;
}

export default useLookupStatuses;
